import React from "react";
import { motion } from "framer-motion";
import "../../styles/WoodsSite.css";
import masterplanImage from "../../assets/meadows-images/meadows-masterplan-2.jpg";

export default function WoodsMasterplan() {
  return (
    <section className="woods-masterplay-section" id="woods-masterplay">
      <motion.div
        initial={{ opacity: 0, y: 45 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <img
          src={masterplanImage}
          alt="Woods masterplan layout"
          className="woods-masterplay-image"
          loading="lazy"
        />
      </motion.div>
    </section>
  );
}
